import detailMessage from './detailMessage';
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { confirmAppointment } from "./api";
import ConfirmShell from "./components/ConfirmShell";
import { useLang } from "./LangContext";

type PageState =
  | { status: "loading" }
  | { status: "ok" }
  | { status: "error"; message: string };

export default function ConfirmPage() {
  const { token } = useParams<{ token: string }>();
  const { t } = useLang();
  const [state, setState] = useState<PageState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    confirmAppointment(token!)
      .then(() => {
        if (cancelled) return;
        setState({ status: "ok" });
      })
      .catch((err) => {
        if (cancelled) return;
        const detail = detailMessage(err, "Confirmation failed");
        setState({ status: "error", message: detail });
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <ConfirmShell>
      {state.status === "loading" && (
        <>
          <div className="confirm-spinner" aria-hidden="true" />
          <h2>{t.confirmingAppointment}</h2>
          <p>{t.oneMoment}</p>
        </>
      )}
      {state.status === "ok" && (
        <>
          <div className="confirm-status-icon ok" aria-hidden="true">✓</div>
          <h2>{t.appointmentConfirmed}</h2>
          <p>{t.thankYouConfirm}</p>
          <p className="close-tab-hint">{t.closeTab}</p>
        </>
      )}
      {state.status === "error" && (
        <>
          <div className="confirm-status-icon error" aria-hidden="true">!</div>
          <h2>{t.somethingWentWrong}</h2>
          <p>{state.message}</p>
          <p className="close-tab-hint">{t.closeTab}</p>
        </>
      )}
    </ConfirmShell>
  );
}
